<template>
  <div class="income-container">
    <h2 class="title">💵 Gestion des recettes</h2>
    <p class="subtitle">Enregistre tes entrées de caisse quotidiennes</p>

    <!-- Formulaire d'ajout -->
    <form @submit.prevent="ajouterRecette" class="form-card">
      <input
        v-model="montant"
        type="number"
        class="form-control"
        placeholder="Montant (MAD)"
      />
      <input
        v-model="employeeName"
        type="text"
        class="form-control"
        placeholder="Nom de l'employé"
      />
      <input
        v-model="date"
        type="date"
        class="form-control"
      />
      <button class="btn-add">Ajouter</button>
    </form>

    <!-- Liste -->
    <div v-if="recettes.length" class="list-section">
      <h4 class="list-title">Liste des recettes</h4>
      <ul class="income-list">
        <li
          v-for="r in recettes"
          :key="r.id"
          class="income-item"
        >
          <div>
            <strong>{{ r.amount }} MAD</strong>
            <span v-if="r.employee_name" class="employee">👤 {{ r.employee_name }}</span>
            <span v-if="r.date" class="date">📅 {{ formatDate(r.date) }}</span>
          </div>
          <button class="btn-delete" @click="supprimerRecette(r.id)">✖</button>
        </li>
      </ul>

      <p class="total">
        Total des recettes :
        <strong>{{ totalAmount }} MAD</strong>
      </p>
    </div>

    <div v-else class="empty-state">
      <p>Aucune recette enregistrée pour le moment.</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Income",
  data() {
    return {
      montant: null,
      employeeName: "",
      date: this.today(),
    };
  },
  computed: {
    ...mapGetters("income", ["all", "totalAmount"]),
    recettes() {
      return this.all;
    },
  },
  methods: {
    ...mapActions("income", ["add", "fetch", "remove"]),
    today() {
      return new Date().toISOString().split("T")[0];
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      return new Date(dateStr).toLocaleDateString();
    },
    async ajouterRecette() {
      if (!this.montant) return;
      await this.add({
        amount: this.montant,
        employee_name: this.employeeName,
        date: this.date,
      });
      this.montant = null;
      this.employeeName = "";
      this.date = this.today();
    },
    async supprimerRecette(id) {
      await this.remove(id);
    },
  },
  created() {
    this.fetch();
  },
};
</script>

<style scoped>
.income-container {
  background: #f8fafc;
  min-height: 100vh;
  padding: 25px 15px 60px;
  font-family: "Poppins", Avenir, Helvetica, sans-serif;
  color: #2b2b2b;
}

.title {
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 4px;
}

.subtitle {
  font-size: 14px;
  color: #6c757d;
  text-align: center;
  margin-bottom: 20px;
}

/* Formulaire */
.form-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.form-control {
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  font-size: 14px;
}

.btn-add {
  background: linear-gradient(135deg, #36b9cc, #258faf);
  color: white;
  border: none;
  padding: 10px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
}
.btn-add:hover {
  opacity: 0.9;
}

/* Liste */
.list-section {
  margin-top: 25px;
}
.list-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}
.income-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.income-item {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  margin-bottom: 10px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.employee {
  display: block;
  color: #555;
  font-size: 13px;
  margin-top: 2px;
}
.date {
  display: block;
  color: #888;
  font-size: 12px;
  margin-top: 2px;
}
.btn-delete {
  background: #f87171;
  border: none;
  color: white;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  font-weight: bold;
  cursor: pointer;
}
.btn-delete:hover {
  background: #ef4444;
}

.total {
  margin-top: 10px;
  font-weight: 600;
  text-align: right;
  color: #1e293b;
}

.empty-state {
  margin-top: 30px;
  text-align: center;
  color: #999;
  font-size: 14px;
}
</style>
